import React, { useState, useEffect } from "react";
import { downloadIcon } from "../../constants/Images";
import { useSelector, useDispatch } from "react-redux";
import { fetchInvoices } from "../../redux/actions/customerAction";
import Blinking from "../../Loaders/Blinking";
import { formatDate } from "../../helpers/genericHelpers";

export default function Invoices() {
  const {
    isInvoicesFetching,
    starting_after,
    invoices_limit,
    invoices,
    isInvoicesFetched
  } = useSelector((state) => state.customersData);
  const [hovered, setHovered] = useState(null);
  const toggleHover = (index) => setHovered(index);
  const dispatch = useDispatch();

  useEffect(() => {
    if (starting_after === "") {
      dispatch(fetchInvoices(starting_after, invoices_limit));
    } else {
      dispatch(fetchInvoices(invoices[invoices.length-1].id, invoices_limit));
    }
  }, []);

  useEffect(() => {
  }, [invoices]);



  const handleFetchMoreInvoices = () => {
    dispatch(fetchInvoices(invoices[invoices.length-1].id, invoices_limit));
  };
  return (
    <>
    {
      isInvoicesFetched ? <> 
      {
        invoices.length !== 0 ? <div className="adminCard">
        <div className="table-responsive userlist-table">
          <table className="table">
            <thead className="text-uppercase">
              <tr style={{ height: "57px" }}>
                <th scope="col" className="rw-pl-50" style={{ width: "300px" }}>
                  Date
                </th>
                <th scope="col" style={{ width: "380px" }}>Customer</th>
                <th scope="col" >
                  Amount
                </th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {invoices &&
                invoices.map((invoice, index) => {
                  return (
                    invoice.rCustomer && <tr
                    className={hovered === index ? "highlighted" : ""}
                    onMouseEnter={() => toggleHover(index)}
                    onMouseLeave={() => toggleHover(null)}
                    key={invoice.id}
                    >
                      <td className="rw-pl-50">
                        <span>{formatDate(invoice.rCustomer.created_at)}</span>
                      </td>
                      
                      <td>
                        <span>{invoice.rCustomer.email}</span>
                      </td>
                      <td>
                        <span className="text-uppercase">
                          {`${invoice.currency} ${invoice.amount/100}`}</span>
                      </td>
  
                      <td>
                        <a href={invoice.invoice_pdf} className="downloadInvoice">
                          <img src={downloadIcon} alt="" />
                          <span>Download</span>
                        </a>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4" className="text-center">
                  {
                    invoices.length >= 15 ? <button
                    className="rs_sm_btn rs_btn text-uppercase mr-2"
                    onClick={handleFetchMoreInvoices}
                  >
                    <span>{isInvoicesFetching ? "Loading..." : "Load more"}</span>
                    
                  </button> : null
                  }
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div> : <div className="adminCard p-4 no__data__card">
        <h3>There are no invoices found!</h3>
    </div>
      
      }
      </> : null
    }
    </>
  );
}
